import React from 'react';
import _ from 'lodash';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import NcDmvHandicapPlacardService from '../../../../../service/NcDmvHandicapPlacardService';
import NcDmvHandicapPlacardModal from './NcDmvHandicapPlacardModal';

export default class NcDl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      headers: [],
    };

    this.comboFields = [
      // TODO
      // {
      //   value: 'externalAccountId',
      //   display: 'Driver License Number',
      // },
      {
        value: 'plateNumber',
        display: 'Placard Number',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'transactionId',
        display: 'Transaction Id',
      },
    ];
  }

  onHandicapPlacardSelect(row) {
    const { rows = [], } = this.state;
    const selectedHandicapPlacard = rows.find(order => order.raw.id === row.id);
    this.setState({
      selectedHandicapPlacard: selectedHandicapPlacard.raw,
    });
  }

  getHandicapPlacards(event) {
    const { search, combo, } = event;
    this.reset();

    const vm = this;
    const headers = [];
    const rows = [];
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = 'nc_handicap_placard';

    const allowedKeys = [
      'id',
      'externalAccountId',
      'customerId',
      'paymentAmount',
      'paymentTransactionId',
      'paymentDate',
    ];

    NcDmvHandicapPlacardService.getNcDmvHandicapPlacardsBySearchCriteria(criteria)
      .then((response) => {
        const { payables: handicapPlacards, } = response.data;
        if (handicapPlacards.length > 0) {
          allowedKeys.forEach((allowedKey) => {
            headers.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
          handicapPlacards.forEach((handicapPlacard) => {
            const filtered = _.pick(handicapPlacard, allowedKeys);
            const date = new Date(filtered.paymentDate);
            filtered.paymentDate = `${date}`;
            rows.push({
              value: Object.values(filtered),
              raw: handicapPlacard,
            });
          });
        }
        vm.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay = (handicapPlacard) => {
    if (!handicapPlacard) {
      return null;
    }

    return (
      <div>
        <p>{`Selected ID: ${handicapPlacard.id}`}</p>
        <hr />
        <NcDmvHandicapPlacardModal selectedHandicapPlacard={handicapPlacard} />
      </div>
    );
  };

  reset() {
    this.setState({
      rows: [],
      headers: [],
      selectedHandicapPlacard: null,
    });
  }

  render() {
    const {
      headers = [],
      rows = [],
      selectedHandicapPlacard,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.getHandicapPlacards(data)}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Handicap Placards">
            <Grid
              headers={headers}
              rows={rows}
              style={{ maxHeight: '800px', overflowY: 'auto', }}
              onRowSelect={data => this.onHandicapPlacardSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedHandicapPlacard)}
        </div>
      </div>
    );
  }
}
